import { BaseQuantity } from "../../interface/functionalityInterface";
// Base quantity
// coherent SI unit is m
export const Length: BaseQuantity = {
  id: "001length",
  name: "length",
  type: "text",
  value: "",
  symbol: "l",
  baseUnit: "m",
  selectedUnit: "m",
  units: [
    { name: "m", fromConst: 1, toConst: 1 },
    { name: "km", fromConst: 1000, toConst: 1 / 1000 },
    { name: "dm", fromConst: 1 / 10, toConst: 10 },
    { name: "cm", fromConst: 1 / 100, toConst: 100 },
    { name: "mm", fromConst: 1 / 1000, toConst: 1000 },
    { name: "inches", fromConst: 1 / 39.3701, toConst: 39.3701 },
    { name: "feet", fromConst: 1 / 3.28084, toConst: 3.28084 },
    { name: "miles", fromConst: 1609.34, toConst: 1 / 1609.34 },
    { name: "yards", fromConst: 1 / 1.09361, toConst: 1.09361 },
    { name: "NM", fromConst: 1852, toConst: 1 / 1852 },
    {
      name: "au",
      fromConst: 1.496 * 10 ** 11,
      toConst: 1 / (1.496 * 10 ** 11),
    },
  ],
};
